<!-- 获取单个停车场空车位接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <!-- <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre> -->
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/editionStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        infoData: {
          payMethod: [{
            titleName: null,
            tabledata: [
              {tableHead: '版本', tdName: 'info1'},
              {tableHead: '说明', tdName: 'info2'},
              {tableHead: '开发者', tdName: 'info3'},
              {tableHead: '更新时间', tdName: 'info4'}
              ],
            td: [
              {info1: 'v1.0.0', info2: 'YDTO发布，实现停车缴费类接口', info3: '罗凯', info4: '2017'},
              {info1: 'v1.1.0', info2: '完善停车缴费类接口', info3: '罗凯', info4: '2017'},
              {info1: 'v1.2.0', info2: '新增停车信息、车场信息、终端控制类接口', info3: '罗凯', info4: '2017-03-21'},
              {info1: 'v1.2.1', info2: '新增商家券、上报类接口', info3: '罗凯', info4: '2017-03-24'},
              {
                info1: 'v1.3.0',
                info2: '新增以下接口1.直接开停车场某个通道的闸机2.直接控制停车场某个通道的显示屏显示内容' +
                  '3.直接控制停车场某个通道的语音板播报内容4.预约接口，支持按次下发。出场失效。5.模拟进场6.模拟出场' +
                  '7.预进场上报接口8.预离场上报接口9.添加黑名单（已做，未联调）10.移除黑名单（已做，未联调）11.暂停月卡' +
                  '12.恢复月卡13.下发计费规则（已做，未联调）-上报端新增重发机制',
                info3: '罗凯',
                info4: '2017-10-16'
              },
              {info1: 'v1.3.1', info2: '门户网站:接入指南增加了重要参数说明,接入指南修改了上报重发机制的说明', info3: '罗凯', info4: '2017-10-24'},
              {
                info1: 'v1.3.2',
                info2: '增加车位预定接口:增加取消车位预定接口、增加开通月卡简约版接口、增加取消月卡简约版接口、' +
                  '增加指定车牌离场提示接口、增加取消指定车牌离场提示接口、增加获取停车位置信息接口、增加通用查费接口接口、' +
                  '增加下发计算系数接口、增加获取授权停车场编码列表接口',
                info3: '罗凯',
                info4: '2017-12-20'
              },
              {
                info1: 'v1.4.0',
                info2: '进出场增加用户信息:整合积分抵扣到开放平台、推送微信消息接口、根据用户标识获取用户信息、' +
                  '车场心跳上报接口、智慧停车支付下单接口、智慧停车通知接口、智慧停车支付查询接口、智慧停车支付退款接口、门户网站',
                info3: '罗凯',
                info4: '2018-02-01'
              },
              {
                info1: 'v1.5.0',
                info2: '创建固定券接口、上报端的重发机制/冻结机制的优化、租用车位接口、取消租用接口、增加共享超时支付接口、' +
                  '设置基本类型显示以及语言播报、设置指定VIP类型显示及语音播报、改造获取进场时间段进场记录接口、' +
                  '改造下发收费规则接口(VEMS)、缴费记录查询接口、黑名单上报接口（VEMS）、改造获取停车记录详情、' +
                  '获取VEMS系统菜单树接口（VEMS）、启用/禁用VEMS菜单功能（VEMS）',
                info3: '罗凯，王殿林',
                info4: '2018-05-14'
              },
              {info1: 'v1.6.0', info2: '缴费兼容云车场、查询车牌已发放商家券、获取车辆身份、第三方优惠类接口', info3: '王殿林', info4: '2018-10-10'},
              {
                info1: 'v1.7.0',
                info2: 'openydt：平台月票--增加通过车牌和时间获取VIP信息、停车信息补录-车辆及车牌图片补录、' +
                  '停车信息补录-车辆进场数据补录、停车信息补录-车辆离场数据补录、Vems月票-获取停车场所有月票信息、' +
                  'Vems月票-清除车场所有月卡规则、Vems月票-清除车牌月卡、Vems月票-获取车场月卡数详情、' +
                  'Vems月票-暂停车牌所有月卡、Vems月票-清除计费规则、车场终端控制-一体机账号新增、车场终端控制-自动登录vems、' +
                  '车位引导-获取车位数据、主动上报-请求历史未接收上报数据、主动上报-异步响应接收上报数据结果，' +
                  'upward：主动上报-告警上报、主动上报-账户登录上报、主动上报-日报表数据上报、' +
                  '上报机制优化-对请求繁忙的授权商进行可配置差异化发送数据，适应极端条件下数据发送需求、' +
                  '进场上报、离场上报、异常（遥控）开闸数据上报增加字段openGateTime,一体机抓拍到开闸的时长（单位：毫秒）。' +
                  'vems2.13以上支持、所有上报接口（除心跳外）添加字段lockKey',
                info3: '王殿林',
                info4: '2018-12-06'
              },
              {
                info1: 'v1.8.0',
                info2: '添加接口或增加支持：获取云停车场通道信息、云停车场开关闸、线上月票创建月票模板、线上开通月票、' +
                  '线上取消月票、缴费账单查询（全局对账用）、补录出场接口supplyCarOut增加字段supplyBillOrNot，' +
                  '是否补录停车账单,默认补录,0不补录，1补录、下发预存款不支持云停车场',
                info3: '王殿林',
                info4: '2018-12-28'
              },
              {info1: 'v1.9.0', info2: '智慧停车开放平台改版', info3: '王殿林', info4: '2019-03-12'},
              {info1: 'v1.9.2', info2: '查询云停车场设备信息、发放通用券返回券编码（已废弃）、查询重发数据情况、' +
                  '续费线上月票、查询云停车场设备信息、查询线上月票', info3: '王殿林', info4: '2019-03-29'},
              {info1: 'v1.9.3', info2: '修复缴费时，PARKING_BILL_DETAIL插入两条账单的bug', info3: '王殿林', info4: '2019-04-17'},
              {info1: 'v1.9.4', info2: '修复bug：云停车场上报的出场图片信息不可访问的bug', info3: '王殿林', info4: '2019-04-28'},
              {
                info1: 'v1.9.5',
                info2: '添加接口：获取云停车场收费规则组集合信息、根据券编码查询商家信息、' +
                  '添加线上月票类型（原有添加线上月票类型更名为添加线上月票类型(对外月票)，其他未变更）、' +
                  '开通线上月票（原有开通线上月票更名为开通线上月票(对外月票)，其他未变更）、' +
                  '智慧停车用户--查询注册用户绑定车辆、智慧停车用户--实名认证、智慧停车用户--确认认证、' +
                  '智慧停车用户--查询公众号用户、车场信息--获取停车场全部信息（添加删除多余字段）',
                info3: '王殿林',
                info4: '2019-05-05'
              },
              {
                info1: 'v1.9.6',
                info2: '1、智慧停车用户：广告-新增广告；' +
                  '2、智慧停车用户：广告-启用/冻结/删除广告；' +
                  '3、智慧停车用户：查询所有用户信息；' +
                  '4、智慧停车用户：查询所有车牌信息；' +
                  '5、去除context-path，保持前后版本兼容；并添加两条配置以使spring boot admin监控生效；' +
                  '6、车场信息--获取停车场全部信息接口增加四个返回字段：areaId、description、email、isFree；' +
                  '7、查费--请求字段添加randomCode和userUniqCode，支持无牌车随机码和用户自主码查费；' +
                  '8、云端控制--云停车场车辆自助进出场，支持CarInOutApi响应参数code不为0时，返回授权商所有信息； ' +
                  '9、云端控制--获取云停车场通道信息，返回字段删除boxStatus（parkconfig将该字段删除）；' +
                  '10、VEMS月票--授权月票；11、VEMS月票--删除授权月票；12、注册用户--注册用户',
                info3: '唐启宇，王殿林',
                info4: '2019-06-06'
              },
              {
                info1: 'v1.10.1',
                info2: '1、授权商接口告警监控；2、城市运营券；3、城市运营积分；4、请求重传历史未接收上报数据，添加3个非必填参数；' +
                  '5、修复查费接口--城市运营券核销时相关bug；6、云端控制--扫码机接入相关接口；7、云端控制--获取设备状态信息；' +
                  '8、创建电子券模板并售卖给商家 createCoupon 添加车场校验：未开通电子优惠的车场禁止创建券',
                info3: '江锦灿，王殿林',
                info4: '2019-06-25'
              },
              {
                info1: 'v1.11.0',
                info2: '1、新增"查询车牌号可用的城市运营券"接口;对停用运营券模板, 发放/回收运营券增加权限检查, ' +
                  '只有创建人才能有权限操作;对查询城市运营券模板信息, 查询城市运营券账单信息, ' +
                  '查询车牌号可用的城市运营券接口的返回数据日期时间格式化为yyyy-MM-dd HH:mm:ss；2、' +
                  '"查询车牌号可用的城市运营券"接口返回数据增加"券模板id"；3、添加接口：向扫码机下发语音播报',
                info3: '江锦灿，王殿林',
                info4: '2019-07-01'
              },
              {
                info1: 'v1.11.1',
                info2: '1、修复缴费时，vems本地优惠和第三方优惠（缴费），不插入线上优惠账单的bug；' +
                  '2、修复线上优惠类型错误bug（所有优惠均展示为商家优惠）；3、修复智慧停车用户-getUsers不支持17X号码段的bug；' +
                  '4、添加上报接口--城市运营券使用券编码变更上报：reportAuthUserAuthPic；' +
                  '5、修复接口--扫码机上报通道绑定关系：对于vems车场，车场名称为null的bug ',
                info3: '王殿林',
                info4: '2019-07-31'
              },
              {
                info1: 'v1.12.0',
                info2: '1、修复bug：添加广告接口（添加微信广告设置的访问链接不可访问）;' +
                  '2、添加接口：云端控制--向屏显发布广告（目前仅支持云停车场）;' +
                  '3、修改接口：智慧停车用户--实名认证（添加5张照片实名认证相关逻辑）;' +
                  '4、添加接口：智慧停车用户--获取广告曝光度统计信息;' +
                  '5、第三方车场业务逻辑（平台接口--查费缴费支持第三方车场，tbl_device_parking的park_sys_type满足==2）;' +
                  '6、添加接口--缴费记录查询（根据进场时间）、车位变更信息上报、智慧停车用户实名认证图片上报',
                info3: '罗凯，王殿林',
                info4: '2019-08-10'
              },
              {
                info1: 'v1.12.1',
                info2: '1、修复bug：newAd 修复adType=7时，availableType设置多选时，不能多选的问题（如选择了进场和离场，但实际只推送离场）' +
                  '2、修复13709；修复13693；监控可配置完全化（不再有相关监控的打印）' +
                  '3、添加接口：停车缴费--查询车场账单信息（getParkBill），与pomp的临停收费报表（新）一致',
                info3: '王殿林',
                info4: '2019-08-24'
              },
              {
                info1: 'v1.12.2',
                info2: '1、智慧停车用户--查询注册用户信息（getUsers），添加两个非必填字段type（用户类型，0游客 1会员。不填则全部）、' +
                  'status（用户状态，0冻结 1有效 2已注销。不填则全部）2、智慧停车用户--查询公众号用户（getAppIdUsers），' +
                  '添加两个非必填字段subscribe（是否关注公众号, 0未关注 1已关注）、' +
                  'status（公众号用户状态，0冻结中 1有效 2已注销,注销后,不显示之前的业务数据）',
                info3: '王殿林',
                info4: '2019-09-18'
              },
              {
                info1: 'v1.13.0',
                info2: '智慧停车数据分析：1、车位周转率；2、获取车场信息；3、交易总揽数据；4、交易趋势数据(以日期获取)；' +
                  '5、交易趋势数据(以数量获取)；6、实时交易数据；7、车场交易数据；8、车场上线情况数据；9、车位使用情况数据；' +
                  '10、停车时长分析数据；11、城市地图车辆分布数据；12、通过超管获取授权商信息；' +
                  '13、下发预存款（vems）支持先付费后离场；14、加入C#、python调用平台代码示例',
                info3: '王殿林',
                info4: '2019-09-29'
              },
              {
                info1: 'v1.13.1',
                info2: '1、修复临停缴费上报优惠券上报商家券和城市运营券couponName和couponOrigin不正确的问题；' +
                  '2、修复:线上支付(包含开放平台)时城市运营券和电子券都统一显示为"商家券"的问题',
                info3: '罗凯',
                info4: '2019-10-16'
              },
              {
                info1: 'v1.13.2',
                info2: '1、修复:当一个车场被多个授权商监听上报时，无停车场分组的能够上报，有停车场分组的由于这是找不到该授权商而无法上报到该授权商服务器的问题',
                info3: '唐启宇',
                info4: '2019-10-22'
              },
              {info1: 'v1.13.3', info2: '1、修复授权商没有去重的问题', info3: '唐启宇', info4: '2019-10-29'},
              {
                info1: 'v1.14.0',
                info2: '停车缴费：1按时间查费(通用查费)支持云停车场；2、预置车辆预存款(云停车场先付费后离场)；' +
                  '3、通知第三方缴费（云停车场）；停车信息：1、获取停车场在场车辆；' +
                  '电子券：1、创建电子券模板并售卖给商家增加财务主体；智慧停车用户：1、根据手机号获取用户标识；' +
                  '2、广告-新增广告当type=4时增加adLocation位置的显示；3、修复查询车牌信息时新能源车牌校验失败的问题；' +
                  '4、获取用户可开发票；5、获取用户历史停车记录；6、获取用户优惠券信息列表；7、智慧停车缴费上报',
                info3: '唐启宇',
                info4: '2020-01-13'
              },
              {
                info1: 'v1.15.0',
                info2: '1、修复：由openydt--请求重传历史未接收上报数据（requestFailDataResend）触发重传历史数据时导致上报服务报错的问题；' +
                  '2、新增：设置默认屏显（setDefaultScreen）（云停车场、vems3.0）、获取出场时间段出场记录（getCarOutList）、' +
                  '商家券支持第三方车场（下发商家券到第三方停车场sendTraderCouponForThi、' +
                  '下发商家券变更信息到第三方停车场updateTraderCouponForThi）；3、修复一些已知问题；',
                info3: '唐启宇',
                info4: '2020-03-10'
              },
              {info1: 'v1.16.0', info2: '1、修改：查询车牌信息（GetCars）增加认证级别authLevel、绑定手机号码phone等字段', info3: '唐启宇', info4: '2020'},
              {
                info1: 'v1.17.0',
                info2: '1、新增：下发预存款支持第三方停车场、查询车场支付账单详情、获取停车H5页面、更新城市运营券模板等接口；' +
                  '2、合并：下发预存款合并为一种接口、开关闸合并为一个接口、自助进出场合并为一个接口；3、修复部分已知问题',
                info3: '唐启宇',
                info4: '2020-04-14'
              },{
                info1: 'v1.18.0',
                info2: '1、新增：车牌校正接口（correctCarNo）；查询授权商小区列表（getAuthCommunities）；' +
                  '查询小区信息（getCommunityInfo）；查询用户通行权限（getCommunityPersonnelInfo）；' +
                  '内部接口获取授权商停车场列表给ydtw（YdtoOpenydtApi.getAuthParkCodes）；' +
                  '自助进出场支持第三方停车场（提供sql，ydtw调用）；2、修复部分内容',
                info3: '唐启宇',
                info4: '2020-04-29'
              },{
                info1: 'v1.19.0',
                info2: '1、修改：广告接口（newAd、startOrFreezeOrDelAd）增加广告类型为8代缴页广告；getParkDetail接口增加parkCode参数响应；' +
                  '2、修复及优化部分功能',
                info3: '唐启宇',
                info4: '2020-06-18'
              },{
                info1: 'v1.20.0',
                info2: '1、、修复及优化部分功能',
                info3: '罗凯',
                info4: '2020-07-24'
              },{
                info1: 'v1.21.0',
                info2: '1、修复及优化部分功能；2、新增修改用户openId接口；3、续费线上月票接口parkCodes改为非必填；4、通知第三方缴费(先扣后离)接口'+
                '增加channelId、channelCode、otherAttr等字段，其中传统停车场v4.2版本以上支持，云停车场v4.0.0版本以上支持',
                info3: '罗凯、唐启宇',
                info4: '2020-09-25'
              },{
                info1: 'v1.22.0',
                info2: '1、新增：查询车辆欠费记录getCarArrearageList、变更注册用户绑定车牌信息syncEnrollUserBindingCar、查询车场到账商户号getParkMerchantInfo、查询车牌可用支付券列表getParkingPayCouponList；' + 
                '2、修复及优化部分功能；2、修改部分接口（添加黑名单、移除黑名单支持云停车场、查询注册用户绑定车辆getEnrollUserBindingCar接口增加认证级别、是否允许查询' +
                '创建电子券模板并售卖给商家createCoupon 接口增加对券模板各字段的校验及限制券名称长度）',
                info3: '唐启宇',
                info4: '2020-11-04'
              },{
                info1: 'v1.23.0',
                info2: '1、修复及优化部分功能；2、修改部分接口（校正车牌接口correctCarNo增加对新车牌的校验、查询可用券列表getParkingPayCouponList增加useRuleFrom、useRuleTo适用范围字段、' +
                '获取坐标范围内的车场/Api/getAreaEpt 增加stopConnectPlatform（上下架状态）字段返回）',
                info3: '周家文、唐启宇',
                info4: '2020-12-16'
              },{
                info1: 'v1.23.1',
                info2: '1、修复及优化部分功能（获取用户优惠券信息列表/City/getUserCouponRecord时间不对的问题）；2、修改：添加黑名单接口Api/addBlackListCar接口支持云停车场isPermament为0',
                info3: '周家文、唐启宇',
                info4: '2020-12-18'
              },{
                info1: 'v4.3.0',
                info2: '1、修复及优化部分功能；2、新增查询微信公众号access_token接口',
                info3: '唐启宇',
                info4: '2021-01-30'
              },{
                info1: 'v4.4.0',
                info2: '1、修复及优化部分功能(修改车辆类型枚举、接口展示名称)'+'2、新增接口搜索'+'3、新增月票记录接口',
                info3: '唐启宇',
                info4: '2021-04-27'
              },{
                info1: 'v4.5.0',
                info2: '1、增加支付方式和修复及优化部分功能'+'2、更新-部分文档、流程图、支持上报接口调试',
                info3: '唐启宇',
                info4: '2021-05-28'
              },{
                info1: 'v4.6.0',
                info2: '1、新增接口-获取清算平台进件信息'+'2、修复及优化部分功能'+'3、新增回收商家券接口',
                info3: '唐启宇',
                info4: '2021-06-22'
              },{
                info1: 'v4.7.0',
                info2: '1、增加批量欠费补缴接口',
                info3: '唐启宇、谢梓壕',
                info4: '2021-07-22'
              },{
                info1: 'v4.8.0',
                info2: '1、查询车场支付账单详情接口(getPaymentRecordDetailList)新增字段(发票状态realInvoiceStatus、开票用户端invoiceClient、开票授权商invoiceCooperator)'+
                '2、新增更新账单发票状态接口(updateInvoiceStatusOfPayBill)'+
                '3、查询车场支付账单详情接口、查询线上月票支付信息接口、缴费接口，新增字段(付款银行bankType)'+
                '4、新增字段第三方交易流水'+
                '5、部分修复优化',
                info3: '唐启宇、谢梓壕',
                info4: '2021-09-27'
              },
            ]
          }]
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/edition.vue